import React from "react";
import toast from "react-hot-toast";
import useApi from "../useApi";
import { IGetTimerRes } from "./index.type";

const useGetTimer = ({
  patientId,
  clinicId,
}: {
  patientId: string;
  clinicId: string;
}) => {
  const [timerData, setTimerData] = React.useState<IGetTimerRes>();

  const url = `/rtm/timer/status?associatedClinicianId=${clinicId}&patientId=${patientId}`;
  const method = "GET";
  const { loading: getTimesLoading, makeApiCall } = useApi({ url, method });

  const getTimer = async () => {
    const { response, error } = await makeApiCall<undefined, IGetTimerRes>();

    if (response?.status === "success") {
      setTimerData(response);
    }

    if (error || !response?.status) {
      const errorObj = error as any;
      const isJwtError =
        errorObj?.status === 401 ||
        errorObj?.response?.status === 401 ||
        (typeof errorObj?.msg === "string" &&
          (errorObj.msg.toLowerCase().includes("jwt") ||
            errorObj.msg.toLowerCase().includes("token") ||
            errorObj.msg.toLowerCase().includes("expired") ||
            errorObj.msg.toLowerCase().includes("unauthorized")));
      if (!isJwtError) {
        const errorMessage =
          typeof error === "object" && error !== null
            ? errorObj?.msg ||
              errorObj?.message ||
              errorObj?.response?.data?.message ||
              "Unable to load timer data. Please check your connection and try again."
            : "Unable to load timer data. Please try again.";

        toast.error(errorMessage);
      }

      setTimerData(undefined);
      console.error("Timer Error:", {
        error,
        response,
        isJwtError,
        statusCode: errorObj?.status || errorObj?.response?.status,
      });
    }
  };

  React.useEffect(() => {
    getTimer();
  }, []);

  return {
    getTimesLoading,
    timerData,
    getTimer,
  };
};

export default useGetTimer;
